import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Payment = Loadable({
    loader: () => import('./Payment'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          uatPaymentState: state.uatPaymentState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          submit,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/payment`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Payment {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
